import * as React from 'react'

function SvgVideo(props, svgRef) {
  return (
    <svg viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M19.548 2.347c.278.15.452.45.452.778v8.75a.881.881 0 01-.452.778.8.8 0 01-.866-.066L12.85 8.212A.89.89 0 0112.5 7.5a.89.89 0 01.349-.712l5.833-4.375a.8.8 0 01.866-.066zM14.768 7.5l3.565 2.675v-5.35L14.767 7.5z"
      />
      <path
        clipRule="evenodd"
        d="M2.5 2.25c-.46 0-.833.392-.833.875v8.75c0 .483.373.875.833.875h9.167c.46 0 .833-.392.833-.875v-8.75c0-.483-.373-.875-.833-.875H2.5zM0 3.125C0 1.675 1.12.5 2.5.5h9.167c1.38 0 2.5 1.175 2.5 2.625v8.75c0 1.45-1.12 2.625-2.5 2.625H2.5c-1.38 0-2.5-1.175-2.5-2.625v-8.75z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgVideo)
export default ForwardRef
